import { preventReClick } from "./btnDebounce";
import { selectMore } from "./selectMore";

/** 挂载自定义指令 */
export function loadDirectives(app) {
  app.directive("selectMore", selectMore);
  app.directive("debounce", preventReClick);
}
